class IdentifyAuthor
{
	/** @type {PopupHelper} */
	_popupHelper = null;
	/** @type {string} */
	_resultContainerSelector = "#identify-popup-result";
	
	constructor()
	{
		let thisObj = this;
		this._popupHelper = new PopupHelper("#identify-popup", {
			popupOKCallback: thisObj._submitRequest.bind(thisObj),
			resetFieldsCallback: thisObj._resetFields.bind(thisObj),
		});	
	}

	open(endpoint)
	{
		this._popupHelper.open(endpoint);
	}

	_resetFields()
	{
		const $reason = $(`${this._popupHelper.containerSelector} #identification-reason`);
		$reason.val("");
	}

	_submitRequest(endpoint)
	{
		const setResult = this._setResult.bind(this);
		const resultContainerSelector = this._resultContainerSelector;
		const popupHelper = this._popupHelper;
		const $reason = $(`${popupHelper.containerSelector} #identification-reason`);
		const data = {
			reason: $reason.val(),
		};
		popupHelper.showLoading();
		dataAction.callClientPostEndpoint(
			endpoint,
			data,
			function (response) {
				popupHelper.close();
				setResult(response);
				openPopup(resultContainerSelector)
			},
			popupHelper.defaultResponseErrorHandler.bind(popupHelper),
			popupHelper.hideLoading.bind(popupHelper)
		);
	}

	_setResult(identity) {
		$(`${this._resultContainerSelector} #identify-author-identity`).text(identity);
	}
}